<template>
  <div v-loading="loading" class="full">
    <w-flow-map-title :rsc-perf-data="rscPerfData" :objtype-id="selectedNode.obj.objtypeId" />
    <div class="default-layout type02-layout">
      <!-- User Process / System Tab -->
      <div class="col row-half">
        <w-flow-map-user-process :rsc-perf-data="rscPerfData" :objtype-id="selectedNode.obj.objtypeId" />
        <w-flow-map-system-tab :system-tab-data="rscPerfData" />
      </div>
      <!-- Server Process -->
      <div class="col row-full">
        <w-flow-map-count-box-container :rsc-perf-data="rscPerfData" title="Server Process">
          <ul class="flowmap-center" slot="countBoxContent">
            <li v-for="data in countBoxDatas" :key="data.rscName" :style="{ backgroundColor: eventColorBg(data.eventlevelId), color: eventColorText(data.eventlevelId) }">
              <i v-if="data.eventlevelId !== 'NM'" class="fa fa-exclamation-triangle" />
              <span>{{data.rscName}}</span>
              <strong>{{data.count}}</strong>
            </li>
          </ul>
          <div slot="arrowContent">
            <w-flow-map-flow-field :perf-records="rscPerfData" perf-key="OR_SYSSTAT/DBOR_BLOCK_CHANGES_COUNT"
            :arrow-settings="{ top: '200px', arrowDirection: 'arrow-right', arrowSize: 'small' }" label="Block Changes" />
            <w-flow-map-flow-field :perf-records="rscPerfData" perf-key="OR_SYSSTAT/DBOR_REDO_ENTRIES_COUNT"
            :arrow-settings="{ top: '270px', arrowDirection: 'arrow-right', arrowSize: 'small' }" label="Redo Entries" />
            <w-flow-map-flow-field :perf-records="rscPerfData" perf-key="OR_SYSSTAT/DBOR_PARSE_COUNT"
            :arrow-settings="{ top: '340px', arrowDirection: 'arrow-right', arrowSize: 'small' }" label="Parse Count" />
            <w-flow-map-flow-field :perf-records="rscPerfData" perf-key="OR_SYSSTAT/DBOR_EXECUTE_COUNT"
            :arrow-settings="{ top: '410px', arrowDirection: 'arrow-right', arrowSize: 'small' }" label="Execute Count" />
          </div>
        </w-flow-map-count-box-container>
      </div>
      <!-- S.G.A & P.G.A -->
      <div class="col row-top-space01">
        <div class="flowmap-box">
          <w-flow-map-flow-field :perf-records="rscPerfData" perf-key="OR_SYSSTAT/DBOR_SESS_LOGICAL_READ_COUNT"
          :arrow-settings="{ top: '70px', arrowDirection: 'arrow-left', arrowSize: 'small' }" />
          <w-flow-map-flow-field :perf-records="rscPerfData" perf-key="OR_SYSSTAT/DBOR_PHYSICAL_WRITE_COUNT"
          :arrow-settings="{ top: '100px', arrowDirection: 'arrow-right', arrowSize: 'medium' }" label="물리적 쓰기"/>
          <w-flow-map-flow-field :perf-records="rscPerfData" perf-key="OR_SYSSTAT/DBOR_REDO_BLOCK_WRITE_COUNT"
          :arrow-settings="{ top: '200px', arrowDirection: 'arrow-right', arrowSize: 'medium' }" label="Redo 블록 쓰기"/>
          <!-- S.G.A -->
          <div class="flowmap-header thema-dark">
            S.G.A
          </div>
          <div class="flowmap-content">
            <div class="flowmap-content-header">
              <ul class="flowmap-list">
                <w-flow-map-item-label :perf-records="rscPerfData" perf-key="DB_MEM_TOTAL_SIZE" :is-value="true" label="Size"/>
              </ul>
            </div>

            <ul class="flowmap-list is-border">
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="OR_MEMSTAT/DBOR_SGA_BUF_CACHE_SIZE" :is-value="true" label="Buffer Cache"/>
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="MEMSTAT/DB_BUF_CACHE_HITRATIO" :is-value="false" label="Buffer Cache 적중률">
                <w-flow-map-progressbar slot="progressbar" :perf-records="rscPerfData" perf-key="MEMSTAT/DB_BUF_CACHE_HITRATIO" />
              </w-flow-map-item-label>
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="OR_MEMSTAT/DBOR_SGA_FIXED_SIZE" :is-value="true" label="Fixed SGA"/>
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="OR_MEMSTAT/DBOR_SGA_KEEP_POOL_SIZE" :is-value="true" label="Keep Pool"/>
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="OR_MEMSTAT/DBOR_SGA_RECYCLE_POOL_SIZE" :is-value="true" label="Recycle Pool"/>
            </ul>

            <ul class="flowmap-list is-border">
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="OR_MEMSTAT/DBOR_SGA_REDO_BUF_SIZE" :is-value="true" label="Redo Buffer"/>
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="OR_MEMSTAT/DBOR_SGA_LOGBUF_RETRY_RATE" :is-value="true" label="Log Buffer 재시도율"/>
            </ul>

            <ul class="flowmap-list is-border">
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="OR_MEMSTAT/DBOR_SGA_SHARED_POOL_SIZE" :is-value="true" label="Shared Pool">
                <w-flow-map-progressbar slot="progressbar" :perf-records="rscPerfData" perf-key="OR_MEMSTAT/DBOR_SGA_SHAREDPOOL_USERATE" />
              </w-flow-map-item-label>
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="OR_MEMSTAT/DBOR_SGA_LIB_CACHE_SIZE" :is-value="true" label="Library Cache">
                <w-flow-map-progressbar slot="progressbar" :perf-records="rscPerfData" perf-key="OR_MEMSTAT/DBOR_SGA_LIB_CACHE_HITRATIO" />
              </w-flow-map-item-label>
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="OR_MEMSTAT/DBOR_SGA_DIC_CACHE_SIZE" :is-value="true" label="Dictionary Cache">
                <w-flow-map-progressbar slot="progressbar" :perf-records="rscPerfData" perf-key="OR_MEMSTAT/DBOR_SGA_DIC_CACHE_HITRATIO" />
              </w-flow-map-item-label>
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="OR_MEMSTAT/DBOR_SGA_SQL_AREA_SIZE" :is-value="true" label="SQL Area"/>
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="OR_MEMSTAT/DBOR_SGA_JAVA_POOL_SIZE" :is-value="true" label="Java Pool"/>
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="OR_MEMSTAT/DBOR_SGA_LARGE_POOL_SIZE" :is-value="true" label="Large Pool"/>
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="LOCK/DB_LOCK_USERATE" :is-value="false" label="Lock 사용률">
                <w-flow-map-progressbar slot="progressbar" :perf-records="rscPerfData" perf-key="LOCK/DB_LOCK_USERATE" />
              </w-flow-map-item-label>
            </ul>
          </div>
        </div>
        <!-- P.G.A -->
        <div class="flowmap-box">
          <div class="flowmap-header thema-dark">
            P.G.A
          </div>
          <div class="flowmap-content">
            <ul class="flowmap-list">
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="OR_MEMSTAT/DBOR_SORT_RATE" :is-value="false" label="메모리 / 디스크 정렬 비율">
                <w-flow-map-progressbar slot="progressbar" :perf-records="rscPerfData" perf-key="OR_MEMSTAT/DBOR_SORT_RATE" />
              </w-flow-map-item-label>
            </ul>
          </div>
        </div>
      </div>
      <!-- BG Process -->
      <div class="col row-top-space01 undercover">
        <div class="flowmap-box medium">
          <div class="flowmap-header thema-dark">
            BG Process
          </div>
          <div class="flowmap-content">
            <div class="flowmap-content-header">
              <ul class="flowmap-list">
                <w-flow-map-item-label :perf-records="rscPerfData" perf-key="PROC/DB_PROC_TOTAL_COUNT" />
              </ul>
            </div>

            <ul class="flowmap-list is-border">
              <w-flow-map-process-box :rsc-perf-data="rscPerfData" rsc-perf-key="OR_PROC/DBOR_PROC_DBWR_COUNT"></w-flow-map-process-box>
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="OR_MEMSTAT/DBOR_FREEBUF_SCAN_RATE" :is-value="false" label="Free Buffer Scan">
                <w-flow-map-progressbar slot="progressbar" :perf-records="rscPerfData" perf-key="OR_MEMSTAT/DBOR_FREEBUF_SCAN_RATE" />
              </w-flow-map-item-label>
            </ul>
            <ul class="flowmap-list is-border">
              <w-flow-map-process-box :rsc-perf-data="rscPerfData" rsc-perf-key="OR_PROC/DBOR_PROC_LGWR_COUNT"></w-flow-map-process-box>
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="OR_MEMSTAT/DBOR_LOGSPACE_REQUEST_REATE" label="Request" />
            </ul>
            <ul class="flowmap-list is-border">
              <w-flow-map-process-box :rsc-perf-data="rscPerfData" rsc-perf-key="OR_PROC/DBOR_PROC_ARCH_COUNT"></w-flow-map-process-box>
            </ul>
            <ul class="flowmap-list is-border">
              <w-flow-map-process-box :rsc-perf-data="rscPerfData" rsc-perf-key="OR_PROC/DBOR_PROC_SMON_COUNT"></w-flow-map-process-box>
              <w-flow-map-process-box :rsc-perf-data="rscPerfData" rsc-perf-key="OR_PROC/DBOR_PROC_CKPT_COUNT"></w-flow-map-process-box>
              <w-flow-map-process-box :rsc-perf-data="rscPerfData" rsc-perf-key="OR_PROC/DBOR_PROC_PMON_COUNT"></w-flow-map-process-box>
            </ul>
          </div>
        </div>
      </div>

      <!-- Disk Storage -->
      <div class="col row-full">
        <div class="flowmap-box">
          <w-flow-map-flow-field :perf-records="rscPerfData" perf-key="OR_SYSSTAT/DBOR_PHYSICAL_READ_COUNT"
          :arrow-settings="{ top: '25px', arrowDirection: 'arrow-left', arrowSize: 'large' }" label="물리적 읽기" />
          <w-flow-map-flow-field :perf-records="rscPerfData" perf-key="OR_SYSSTAT/DBOR_ARCHIVELOG_WRITE_COUNT"
          :arrow-settings="{ top: '400px', arrowDirection: 'arrow-left', arrowSize: 'u-line' }" label="Archive 로그쓰기" />

          <div class="flowmap-header thema-dark">
            Disk Storage
          </div>

          <div class="flowmap-content">
            <ul class="flowmap-list is-border">
              <li><i class="fas fa-bullseye" /> <strong>Database Files</strong></li>
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="TABLESPACE/DB_TABLESPACE_TOTSIZE" label="사용률">
                <w-flow-map-progressbar slot="progressbar" :perf-records="rscPerfData" perf-key="TABLESPACE/DB_TABLESPACE_USERATE" />
              </w-flow-map-item-label>
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="TABLESPACE/DB_TABLESPACE_USEDSIZE" label="사용량" />
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="OR_STRG/DBOR_ONLINE_TS_COUNT" label="테이블 공간 수" />
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="OR_STRG/DBOR_ONLINE_FILE_COUNT" label="파일 수" />
            </ul>

            <ul class="flowmap-list is-border">
              <li><i class="fas fa-bullseye" /> <strong>Redo Logs</strong></li>
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="OR_STRG/DBOR_REDOLOGFILE_USERATE" :is-value="false" label="사용률">
                <w-flow-map-progressbar slot="progressbar" :perf-records="rscPerfData" perf-key="OR_STRG/DBOR_REDOLOGFILE_USERATE" />
              </w-flow-map-item-label>
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="OR_STRG/DBOR_REDOLOGFILE_GROUP_COUNT" label="그룹 수" />
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="OR_STRG/DBOR_REDOLOGFILE_SIZE" label="사용량" />
            </ul>

            <ul class="flowmap-list is-border">
              <li><i class="fas fa-bullseye" /> <strong>Archive Logs</strong></li>
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="OR_SYSSTAT/DBOR_ARCHIVELOG_TOTAL_SIZE" label="사용량" />
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="OR_STRG/DBOR_ARCHIVELOG_DEST_COUNT" label="도착지 수" />
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="OR_STRG/DBOR_ARCHIVELOG_DISK_COUNT" label="File System 수" />
            </ul>

            <ul class="flowmap-list is-border">
              <li><i class="fas fa-bullseye" /> <strong>File System</strong></li>
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="DISK/DISK_USERATE" :is-value="false" label="사용률" >
                <w-flow-map-progressbar slot="progressbar" :perf-records="rscPerfData" perf-key="DISK/DISK_USERATE" />
              </w-flow-map-item-label>
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="DISK/DISK_TOTSIZE" label="전체 크기" />
              <w-flow-map-item-label :perf-records="rscPerfData" perf-key="DISK/DISK_USEDSIZE" label="사용량" />
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import msgUtil from '@/utils/message';
import FlowMapAPI from '@/api/performance/database/flow-map';
import WRscPerfEventTextLabel from '@/components/textLabel/RscPerfEventTextLabel';
import WFlowMapSystemTab from '@/views/performance/node/database-flow-map/components/FlowMapSystemTab';
import WFlowMapProgressbar from './components/FlowMapProgressbar';
import WFlowMapTitle from './components/FlowMapTitle';
import WFlowMapUserProcess from './components/FlowMapUserProcess';
import WFlowMapCountBoxContainer from './components/FlowMapCountBoxContainer';
import WFlowMapFlowField from './components/FlowMapFlowField';
import WFlowMapItemLabel from './components/FlowMapItemLabel';
import WFlowMapProcessBox from './components/FlowMapProcessBox';

export default {
  name: 'WOracleFlowMap',
  components: {
    WRscPerfEventTextLabel,
    WFlowMapSystemTab,
    WFlowMapTitle,
    WFlowMapUserProcess,
    WFlowMapProgressbar,
    WFlowMapCountBoxContainer,
    WFlowMapFlowField,
    WFlowMapItemLabel,
    WFlowMapProcessBox,
  },
  props: {
    active: Boolean,
    selectedNode: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      rscPerfData: {},
      countBoxDatas: [],
    };
  },
  computed: mapGetters(['eventlevelInfo']),
  watch: {
    selectedNode: {
      immediate: true,
      handler() {
        if (!this.active) {
          return;
        }
        // handler (to, from)
        // 선택된 DB가 변경될 때 수행해야할 로직 작성.
        this.loadData();
      },
    },
    /**
     * [Flow 맵] 탭 활성화 시 재로드
     * @param  {[type]} active [description]
     * @return {[type]}        [description]
     * @author jda
     */
    active(active) {
      if (active) {
        this.loadData();
      }
    },
  },
  methods: {
    /**
     * FlowMap의 데이터를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadData() {
      const params = {
        objId: this.selectedNode.obj.objId,
        objtypeId: this.selectedNode.obj.objtypeId,
      };
      this.loading = true;
      FlowMapAPI.getRscPerfAndEventOfDatabase(params).then((response) => {
        if (response.data.success) {
          // 응답 데이터 처리
          this.rscPerfData = response.data.data[0];
          this.countBoxDatas = [
            {
              // rscName: this.rscPerfData['OR_SERV/DBOR_SERVER_TOTAL_COUNT/RSCNAME'],
              rscName: 'Total',
              // count: 62,
              count: this.rscPerfData['OR_SERV/DBOR_SERVER_TOTAL_COUNT'],
              eventlevelId: this.rscPerfData['OR_SERV/DBOR_SERVER_TOTAL_COUNT/EVENTLEVEL_ID'],
              unit: this.rscPerfData['OR_SERV/DBOR_SERVER_TOTAL_COUNT/UNIT'],
            },
            {
              rscName: this.rscPerfData['OR_SERV/DBOR_SERVER_DEDICATED_COUNT/RSCNAME'],
              count: this.rscPerfData['OR_SERV/DBOR_SERVER_DEDICATED_COUNT'],
              eventlevelId: this.rscPerfData['OR_SERV/DBOR_SERVER_DEDICATED_COUNT/EVENTLEVEL_ID'],
              unit: this.rscPerfData['OR_SERV/DBOR_SERVER_DEDICATED_COUNT/UNIT'],
            },
            {
              rscName: this.rscPerfData['OR_SERV/DBOR_SERVER_SHARED_COUNT/RSCNAME'],
              count: this.rscPerfData['OR_SERV/DBOR_SERVER_SHARED_COUNT'],
              eventlevelId: this.rscPerfData['OR_SERV/DBOR_SERVER_SHARED_COUNT/EVENTLEVEL_ID'],
              unit: this.rscPerfData['OR_SERV/DBOR_SERVER_SHARED_COUNT/UNIT'],
            },
            {
              rscName: this.rscPerfData['OR_SERV/DBOR_SERVER_DISPATCHER_COUNT/RSCNAME'],
              count: this.rscPerfData['OR_SERV/DBOR_SERVER_DISPATCHER_COUNT'],
              eventlevelId: this.rscPerfData['OR_SERV/DBOR_SERVER_DISPATCHER_COUNT/EVENTLEVEL_ID'],
              unit: this.rscPerfData['OR_SERV/DBOR_SERVER_DISPATCHER_COUNT/UNIT'],
            },
            {
              rscName: this.rscPerfData['OR_SERV/DBOR_SERVER_PARAQUERY_COUNT/RSCNAME'],
              count: this.rscPerfData['OR_SERV/DBOR_SERVER_PARAQUERY_COUNT'],
              eventlevelId: this.rscPerfData['OR_SERV/DBOR_SERVER_PARAQUERY_COUNT/EVENTLEVEL_ID'],
              unit: this.rscPerfData['OR_SERV/DBOR_SERVER_PARAQUERY_COUNT/UNIT'],
            },
            {
              rscName: this.rscPerfData['OR_SERV/DBOR_SERVER_JOBQUEUE_COUNT/RSCNAME'],
              count: this.rscPerfData['OR_SERV/DBOR_SERVER_JOBQUEUE_COUNT'],
              eventlevelId: this.rscPerfData['OR_SERV/DBOR_SERVER_TOTAL_COUNT/EVENTLEVEL_ID'],
              unit: this.rscPerfData['OR_SERV/DBOR_SERVER_TOTAL_COUNT/UNIT'],
            },
          ];
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'Flow 맵 정보', false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'Flow 맵 정보', false));
      }).finally(() => {
        this.loading = false;
      });
    },
    eventColorBg(eventlevelId) {
      if (!isEmpty(this.eventlevelInfo[eventlevelId])) {
        return this.eventlevelInfo[eventlevelId].eventlevelColorBg;
      }
      return null;
    },
    eventColorText(eventlevelId) {
      if (!isEmpty(this.eventlevelInfo[eventlevelId])) {
        return this.eventlevelInfo[eventlevelId].eventlevelColorText;
      }
      return null;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/database-flow-map/OracleFlowMap.vue